import { render, staticRenderFns } from "./ChbEditCountryForm.vue?vue&type=template&id=6275a7a2&scoped=true"
import script from "./ChbEditCountryForm.vue?vue&type=script&lang=js"
export * from "./ChbEditCountryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6275a7a2",
  null
  
)

export default component.exports